import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
// Constants
import { primaryColor, primaryColorHover } from "../config/constants";

const commonStyles = css`
  margin: ${({ margin }) => margin && margin};
  padding: ${({ padding }) => (padding ? padding : `10px`)};
  width: ${({ width }) => width && width};
  height: ${({ height }) => (height ? height : `38px`)};
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 5px;
  background-color: ${({ active, background }) => (!active && background ? background : primaryColor)};
  cursor: pointer;
  pointer-events: ${({ active, background }) => (!active && background ? "none" : "auto")};
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${({ active, background }) => (!active && background ? background : primaryColorHover)};
  }
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
  }
  @media (max-width: 610px) {
    margin: ${({ margin610 }) => margin610 && margin610};
    width: ${({ width610 }) => width610 && width610};
  }
`;

const NavigationLink = styled(Link)`
  ${commonStyles}
`;
const NavigationBtn = styled.button`
  ${commonStyles}
`;
const NavImg = styled.img`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;
const NavName = styled.p`
  font-size: 14px;
  font-weight: bold;
  color: #fff;
`;

const ButtonWithIcon = ({
  icon,
  name,
  path,
  onClick,
  padding,
  width,
  width610,
  width910,
  height,
  margin,
  margin610,
  active,
  background,
}) => {
  return path ? (
    <NavigationLink
      to={path}
      margin={margin}
      margin610={margin610}
      padding={padding}
      width={width}
      width610={width610}
      width910={width910}
      height={height}
      active={active}
      background={background}
    >
      <NavImg src={icon} alt="ico-link" />
      <NavName>{name}</NavName>
    </NavigationLink>
  ) : (
    <NavigationBtn
      onClick={onClick}
      margin={margin}
      margin610={margin610}
      padding={padding}
      width={width}
      width610={width610}
      width910={width910}
      height={height}
      active={active}
      background={background}
    >
      <NavImg src={icon} alt="ico-link" />
      <NavName>{name}</NavName>
    </NavigationBtn>
  );
};

export default ButtonWithIcon;
